import { makeStyles } from "@mui/styles";
import { COLOR_CONSTANTS } from "../../../../../constants/StyleConstants";

const LinkBoxGridStyles = makeStyles((theme) => ({
  container: {
    padding: "10px 20px 1rem"
  },
  linkBoxContainer: {
    display: "flex"
  },
  linkBox: {
    borderBottom: `1px dotted ${COLOR_CONSTANTS.COLOR_GRAY_30}`,
    width: "95%",
    paddingBottom: "1rem",
    marginBottom: "0rem"
  },
  link: {
    color: COLOR_CONSTANTS.GENOMIC_LIFE_LIGHT_GRAY,
    fontWeight: "bold",
    "&:hover": {
      textDecoration: "underline"
    }
  }
}));

export default LinkBoxGridStyles;
